import React from 'react';

export default function PrivacyPolicy({ onNavigate }) {
  return (
    <div style={{ maxWidth: '1200px', margin: '40px auto', padding: '20px' }}>
      <div style={{
        backgroundColor: '#2a2a2a',
        border: '1px solid #3a3a3a',
        borderRadius: '12px',
        padding: '40px',
        color: '#fff'
      }}>
        <button
          onClick={() => onNavigate && onNavigate('leaderboard')}
          style={{
            backgroundColor: '#A78BFA',
            color: '#fff',
            border: 'none',
            padding: '10px 20px',
            borderRadius: '8px',
            cursor: 'pointer',
            fontSize: '0.875rem',
            fontWeight: '600',
            marginBottom: '24px'
          }}
          onMouseOver={(e) => e.target.style.backgroundColor = '#9333ea'}
          onMouseOut={(e) => e.target.style.backgroundColor = '#A78BFA'}
        >
          ← Back to Home
        </button>
        <h1 style={{ color: '#A78BFA', marginBottom: '24px' }}>EmberX</h1>
        <h2 style={{ color: '#FFB84D', marginBottom: '32px' }}>Privacy Policy</h2>

        <div style={{ lineHeight: '1.8', color: '#d1d5db' }}>
          <section style={{ marginBottom: '32px' }}>
            <h3 style={{ color: '#A78BFA', marginBottom: '16px' }}>1. Data Collection</h3>
            <p>EmberX is a non-custodial DeFi application. We do not ask you to create an account or submit identity documents to use the core swap and liquidity features.</p>
            <p style={{ marginTop: '16px' }}>When you interact with the protocol, blockchain data (such as wallet addresses, transaction hashes, and token amounts) is publicly available on Flare and may be visible to anyone.</p>
          </section>

          <section style={{ marginBottom: '32px' }}>
            <h3 style={{ color: '#A78BFA', marginBottom: '16px' }}>2. Cookies</h3>
            <p>We may use essential cookies or local storage to keep the interface working (for example: saving UI preferences, selected tokens, or dismissing banners). These are used to provide a stable experience.</p>
          </section>

          <section style={{ marginBottom: '32px' }}>
            <h3 style={{ color: '#A78BFA', marginBottom: '16px' }}>3. Analytics</h3>
            <p>We may use privacy-friendly analytics to understand traffic and improve the website and dApp. Analytics data may include device type, pages viewed, and approximate location (based on IP), but is not intended to identify you personally.</p>
          </section>

          <section style={{ marginBottom: '32px' }}>
            <h3 style={{ color: '#A78BFA', marginBottom: '16px' }}>4. Third-Party Services</h3>
            <p>Wallet connection providers, RPC endpoints, and infrastructure vendors may process limited technical data to deliver their services. Their privacy practices are governed by their own policies.</p>
          </section>

          <section style={{ marginBottom: '32px' }}>
            <h3 style={{ color: '#A78BFA', marginBottom: '16px' }}>5. Security</h3>
            <p>We follow reasonable security practices to protect the website and our systems. However, no method of transmission or storage is 100% secure, and DeFi carries inherent risks.</p>
          </section>

          <section style={{ marginBottom: '32px' }}>
            <h3 style={{ color: '#A78BFA', marginBottom: '16px' }}>6. Changes to This Policy</h3>
            <p>We may update this Privacy Policy from time to time. If we make material changes, we will update this page and its date.</p>
          </section>

          <section style={{ marginBottom: '32px' }}>
            <h3 style={{ color: '#A78BFA', marginBottom: '16px' }}>7. Contact</h3>
            <p>If you have questions about this policy, contact the EmberX team at <a href="mailto:support@EmberX.xyz" style={{ color: '#FFB84D', textDecoration: 'underline' }}>support@EmberX.xyz</a>.</p>
          </section>
        </div>
      </div>
    </div>
  );
}
